import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { SiteLayout } from "@/components/site/SiteLayout";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { RfqProvider } from "@/components/site/RfqContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Category, { NotFoundBlock } from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import Contact from "@/pages/Contact";
import Industries from "@/pages/Industries";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <RfqProvider>
        <SmoothScroll />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<Category />} />
            <Route path="/products/:cat/:slug" element={<ProductDetail />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFoundBlock />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </RfqProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
